import { render, staticRenderFns } from "./feedbackManagement.vue?vue&type=template&id=5cd6e041&scoped=true"
import script from "./feedbackManagement.vue?vue&type=script&lang=js"
export * from "./feedbackManagement.vue?vue&type=script&lang=js"
import style0 from "./feedbackManagement.vue?vue&type=style&index=0&id=5cd6e041&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6e041",
  null
  
)

export default component.exports